export const visit = (vm, at) => {
vm(require("documents-lib/lang/view/cs.lyaml"));
at({ "cs": { "public": { "sampleString": "Vzorov\xFD \u0159et\u011Bzec" } } });
};